<div class="container-fluid overflow-auto h-100">
  <div class="row h-100 align-items-start">
    <div class="col-12 col-md-5 col-lg-4 align-self-top align-self-md-stretch bg-primary-inverse">
      <div class="h-25 d-none d-md-block">
        <div class="px-1 py-4 px-lg-3 float-end">
          <div class="brand brand-split"></div>
        </div>
      </div>
      <div class="h-75 text-white text-md-right d-flex flex-column">
        <div class="row">
          <div class="col">
            <div split-left=""
                 class="px-1 py-3 px-lg-3">
              <h2 class="title mt-2 mt-lg-4">ERA</h2>
              <p class="mt-2 mt-lg-4">Please login to access the site.</p>
            </div>
          </div>
          <div class="col-auto d-block d-md-none">
            <div split-left-sm-brand=""
                 class="px-1 py-3">
              <div class="brand"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-5 col-lg-4 align-self-top align-self-md-stretch">
      <div class="h-25 d-none d-md-block"></div>
      <div class="h-75 d-flex flex-column">
        <div class="px-1 py-3 px-lg-3 d-flex flex-column mt-1">
          <h3 class="title text-primary mt-2 mt-lg-4">Log in.</h3>
          <div class="mt-2 mt-lg-4">
            @if (ids4ConfigId) {
              <button type="button"
                      class="btn btn-outline-primary"
                      (click)="login(ids4ConfigId)">Classic</button>
            }
            @if (azureb2cConfigId) {
              <button type="button"
                      class="btn btn-outline-secondary"
                      (click)="login(azureb2cConfigId)">
                Azure AD B2C
              </button>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-2 col-lg-4 align-self-top align-self-stretch">
      <div class="h-100 d-flex flex-column">
        <div split-right-footer=""
             class="px-1 py-4 px-lg-3 mt-auto d-flex justify-content-end"></div>
      </div>
    </div>
  </div>
</div>